import {Component, InjectionKey} from "vue";

export default interface TextareaButtonInterface {
    id: string;
    component: Component;
    withDropdown?: boolean;
    isRightSide?: boolean;
    hideInDropdown?: boolean;
    alwaysPinned?: boolean;
    availableInCabinet?: boolean;
}

export const isTextareaButtonInDropdown: InjectionKey<boolean> = Symbol();

export const COPILOT_BUTTON_ID = "copilot";
export const TRANSLATE_BUTTON_ID = "translate";
export const COPILOT_SUGGEST_TOGGLE_BUTTON_ID = "copilotSuggest";
export const MESSAGES_TEMPLATES_BUTTON_ID = "messageTemplates";
export const SEND_PAYMENT_FORM_TAB_BUTTON_ID = "sendPaymentFormTab";
export const SEND_FORM_TAB_BUTTON_ID = "sendFormTab";
export const SEND_HTML_TAB_BUTTON_ID = "sendHtmlTab";
export const REQUEST_RATE_BUTTON_ID = "requestRate";
export const REQUEST_CONTACT_BUTTON_ID = "requestContact";
export const REQUEST_TIP_BUTTON_ID = "requestTip";
export const START_BOT_BUTTON_ID = "startBot";
export const KNOWLEDGE_BASE_BUTTON_ID = "knowledgeBase";
export const CLOSE_DIALOG_BUTTON_ID = "closeDialog";
export const RITHORIC_QUESTION_BUTTON_ID = "rithoricQuestion";
export const TOGGLE_MUTE_BUTTON_ID = "toggleMute";
export const UPLOAD_FILE_BUTTON_ID = "uploadFile";
export const EMOJI_BUTTON_ID = "emoji";
export const VOICE_MESSAGE_BUTTON_ID = "voiceMessage";
export const VOICE_TRANSCRIBE_BUTTON_ID = "voiceTranscribe";

export const HIDDEN_BY_DEFAULT_BUTTON_IDS = [
    SEND_PAYMENT_FORM_TAB_BUTTON_ID,
    SEND_FORM_TAB_BUTTON_ID,
    SEND_HTML_TAB_BUTTON_ID,
    RITHORIC_QUESTION_BUTTON_ID,
    REQUEST_RATE_BUTTON_ID,
    VOICE_MESSAGE_BUTTON_ID,
    REQUEST_CONTACT_BUTTON_ID
]
